export const wpClassNames = {
    CALLOUT_BOX: 'cdm-callout-box',
    CALLOUT_BOX_CONTAINER: 'boxContainer',
    CALLOUT_BOX_CONTENT: 'boxContent',
    CALLOUT_BOX_TITLE: 'cdm-callout-box-title',
}